module.exports = __webpack_public_path__ + "assets/img/scroll-top.863d0775.png";